import React from 'react'
import { checkTextTranslation, translate } from '../../utils/useful'

class TableStockInput extends React.Component {
    state = {
    }

    componentDidMount() {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    render() {
        return (
            <div className="w-100 h-100 flexcc">
                {this.props.data?.track ? (
                    <>
                        {this.props.data?.outOfStock ? (
                            <p className="text-smaller color-gray-1 text-semibold w-100 text-start" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{translate('Out of stock')}</p>
                        ) : (
                            <div className="w-100 text-start">
                                <p>{this.props.data?.count ?? 0}</p>
                            </div>
                        )}
                    </>
                ) : (
                    <p className="text-smaller color-gray-1 text-semibold w-100 text-start" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{translate('Unlimited')}</p>
                )}
            </div>
        )
    }
}

export default TableStockInput;